export default __webpack_public_path__ + "static/media/Tail Whisk.bb40bbae.png";